export default "__VITE_ASSET__onMfA6BC__"